import React, { Fragment } from 'react';
import { SectionHeader } from '@components';
import { BOTTOM_INDENTS, COLORS, RIGHT_INDENTS } from '@constants';
import { Divider, Loader, Typography } from '@ui';
import Card from './components/Card';
import { StyledCard, StyledWrapper } from './styled';

const TopSites = ({ data = [], pending = true, type = 'performance', ...rest }) => {
    const isHomePage = type === 'homepage';

    if (pending)
        return (
            <div style={{ position: 'relative', width: '100%', paddingTop: '48px' }}>
                <Loader overlayColor='rgba(244, 244, 244, 0.8)' />
            </div>
        );

    if (!data?.length) return null;

    const renderCards = () => {
        return data.map((item) => <Card key={item?.name} info={item} type={type} />);
    };

    return isHomePage ? (
        <Fragment>
            <Divider style={{ borderBlockStart: `1px solid ${COLORS.$gray20Black}` }} margin='48px 0' />
            <SectionHeader data-e2e='home_top-sites_title' title='Top sites' style={BOTTOM_INDENTS.L} />
            <StyledWrapper {...rest}>{renderCards()}</StyledWrapper>
        </Fragment>
    ) : (
        <StyledCard
            {...rest}
            title={
                <Typography.Text
                    data-e2e='performance_top-sites_title'
                    color={COLORS.$gray40Black}
                    type='badgeMedium'
                    style={RIGHT_INDENTS.S}
                >
                    Top sites
                </Typography.Text>
            }
        >
            {renderCards()}
        </StyledCard>
    );
};

export default TopSites;
